// extracted by css-extract-rspack-plugin
module.exports =  {"evaluator":"Competency-XNPE__evaluator","archived-competency":"Competency-Je7w__archived-competency","title":"Competency-auhf__title","footer":"Competency-Gi7r__footer"};